import Users from './Users'

export default Users



// WEBPACK FOOTER //
// ./src/components/Users/index.js